export enum SunlabsSides {
  LeftRight = "LeftRight",
  FrontBack = "FrontBack",
  Left = "Left",
  Right = "Right",
  Back = "Back",
  Front = "Front",
  Top = "Top",
  Bottom = "Bottom",
}
